import VirtualList from 'components/VirtualList';
import Modal from 'components/Modal';
import { useState } from 'react';
import useMounted from 'hooks/useMounted';
import Test from 'components/Test';
import { shuffleArray } from 'helpers';
import dictionary from 'helpers/dictionary';
const shuffle = shuffleArray(dictionary);

const App = () => {
  const [test, setTest] = useState(false);
  const [selected, setSelected] = useState(0);
  const [status, setStatus] = useState(shuffle.map(x => null));
  const [itemStatus, setItemStatus] = useState(shuffle.map(x => null));
  const [search, setSearch] = useState('');
  const [active, setActive] = useState(null);

  const onChange = (e) => {
    setSearch(e);
  };

  const onReset = () => {
    setTest(false);
    setStatus(shuffle.map(x => null));
    setItemStatus(shuffle.map(x => null));
  };

  const onResponse = (e) => {
    const itemIndex = dictionary.findIndex(x => x.title === shuffle[selected].title);
    status[selected] = e;
    itemStatus[itemIndex] = e;
    setStatus([...status]);
    setItemStatus([...itemStatus]);
  }

  useMounted(() => {
    window.onkeydown = function (e) {
      if (e.keyCode === 70 && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        document.getElementById('Search').focus();
      }
    }
  });

  return (
    <>
      <header className="Header">
        <div className="Logo">
          <img src="/img/javascript.svg" alt="JS Library" />
          <div className="Text">Library</div>
        </div>
        <input id="Search" className="Search" size="large" placeholder="Type something to search..." onChange={(e) => onChange(e.target.value)} />
        <Test
          count={test && `${status.filter(x => x === true).length}/${status.length}`}
          selected={shuffle[selected]}
          index={selected}
          length={shuffle.length}
          status={status[selected]}
          onResponse={onResponse}
          onReset={onReset}
          test={test} setTest={setTest}
          onPrev={() => setSelected(selected - 1)}
          onNext={() => setSelected(selected + 1)}
        />
      </header>
      {active &&
        <Modal data={active} onClose={() => setActive(null)} />
      }
      <VirtualList dictionary={dictionary} search={search} onClick={setActive} status={test && itemStatus} />
    </>
  );
}

export default App;
